import {ApiError} from './api-error';
import {BaseError} from './base-error';
import {CrashlyticsBackend} from './crashlytics';

// Do NOT commit that change into the repo.
/** @const {String} ['Set this to `true` to enable console logging of error tracking events.'] */
const LOG_ERROR = false;

export class ErrorTrackingUtil {
  backend: any;

  constructor({backend}: any) {
    this.backend = backend;
  }

  trackError = (error: any, name: any) => {
    return this.backend.logError(new BaseError({name, error}));
  };

  trackApiError = ({status, endPoint, body, ...args}: any) => {
    return this.backend.logError(
      new ApiError({status, endPoint, body, ...args}),
    );
  };
}

let ErrorTrackingUtilDefaultInstance: any = null;

export const getErrorTrackingUtilDefaultInstance = () => {
  if (ErrorTrackingUtilDefaultInstance === null) {
    ErrorTrackingUtilDefaultInstance = new ErrorTrackingUtil({
      backend: new CrashlyticsBackend({verbose: LOG_ERROR}),
    });
  }
  return ErrorTrackingUtilDefaultInstance;
};
